import { Link } from 'react-router';

import styles from './LogoStrip.module.css';

interface LogoItem {
  name: string;
  src?: string;
  subtitle?: string;
}

interface CredibilityLine {
  accent?: 'amber';
  href?: string;
  text: string;
}

interface LogoStripProps {
  credibilityLines?: readonly CredibilityLine[];
  eyebrow: string;
  logos: readonly LogoItem[];
}

export function LogoStrip({
  credibilityLines = [],
  eyebrow,
  logos,
}: LogoStripProps) {
  return (
    <div className={styles.strip}>
      <p className={styles.eyebrow}>{eyebrow}</p>

      <div className={styles.logos}>
        {logos.map((logo) => (
          <div className={styles.logoItem} key={logo.name}>
            {logo.src ? (
              <img alt={logo.name} className={styles.logoImage} loading="lazy" src={logo.src} />
            ) : (
              <span className={styles.logoText}>{logo.name}</span>
            )}
            {logo.subtitle ? (
              <span className={styles.logoSubtitle}>{logo.subtitle}</span>
            ) : null}
          </div>
        ))}
      </div>

      {credibilityLines.length > 0 ? (
        <div className={styles.credibility}>
          {credibilityLines.map((line) =>
            line.href ? (
              <Link
                className={styles.credibilityItem}
                key={line.text}
                to={line.href}
              >
                {line.accent === 'amber' ? (
                  <span aria-hidden="true" className={styles.accentDot} data-accent="amber" />
                ) : null}
                <span>{line.text}</span>
              </Link>
            ) : (
              <p className={styles.credibilityItem} key={line.text}>
                {line.accent === 'amber' ? (
                  <span aria-hidden="true" className={styles.accentDot} data-accent="amber" />
                ) : null}
                <span>{line.text}</span>
              </p>
            ),
          )}
        </div>
      ) : null}
    </div>
  );
}
